const SDK_VERSION = '7.80.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
